import { render, staticRenderFns } from "./ReportStatistics_PrivateTeam.vue?vue&type=template&id=c5fce524&scoped=true"
import script from "./ReportStatistics_PrivateTeam.vue?vue&type=script&lang=js"
export * from "./ReportStatistics_PrivateTeam.vue?vue&type=script&lang=js"
import style0 from "./ReportStatistics_PrivateTeam.vue?vue&type=style&index=0&id=c5fce524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fce524",
  null
  
)

export default component.exports